import type { FC } from 'react'

import { Button } from '@skytech/ui/Button'
import { useNavigate } from 'react-router-dom'
import { twJoin } from 'tailwind-merge'

import { useAppContext } from '@/app/index.context'
import { Translation } from '@/app/translations/Translation'
import { useHasGlobalAccess } from '@/hooks/access'
import useUser from '@/hooks/user'
import { APP_ROUTES } from '@/util/app-routes'

import { BreadCrumbs } from './BreadCrumbs'
import { setMultipleDrillDownAction } from './context/actions.context'
import { useDrillDownContext } from './context/index.context'

export const ChoseReportType: FC = () => {
  const user = useUser()
  const hasGlobalAccess = useHasGlobalAccess()
  const { state, dispatch } = useDrillDownContext()

  if (!user || !user.customerId) return null

  const navigate = useNavigate()

  const qs = new URLSearchParams({
    type: 'customer',
    typeId: String(user.customerId),
    period: String(state.period),
    year: String(state.year),
  }).toString()

  const onClick = (route: string) => {
    dispatch(setMultipleDrillDownAction({ type: 'customer', typeId: String(user.customerId) }))
    navigate(route)
  }

  return (
    <>
      <BreadCrumbs />
      {/* <DrillDownOptions /> */}
      <div className="visible mt-10 flex items-center justify-around gap-8">
        <LinkComponent
          onClick={() => onClick(`${APP_ROUTES.REPORTS_DRILL_DOWN_SERVICE}?${qs}`)}
          label="Services"
        />
        <LinkComponent
          onClick={() => onClick(`${APP_ROUTES.REPORTS_DRILL_DOWN_DEPARTMENT}?${qs}`)}
          label="Dept. / Cost Center"
        />
        {!hasGlobalAccess && (
          <LinkComponent
            onClick={() => onClick(`${APP_ROUTES.REPORTS_DRILL_DOWN_COST_OBJECT}?${qs}`)}
            label="Number / Cost Item"
          />
        )}
      </div>
    </>
  )
}

const LinkComponent: FC<{ onClick: () => void; label: string }> = ({ onClick, label }) => {
  const { whiteLabel } = useAppContext()

  return (
    <Button
      onClick={onClick}
      variant="primary"
      className={twJoin(
        'h-20 w-96 text-2xl transition-all duration-[250ms] ease-out hover:scale-[106%] hover:brightness-110',
        whiteLabel === 'mobit' && 'bg-mobit-darkBlue brightness-100'
      )}
    >
      <Translation id={label} />
    </Button>
  )
}
